function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleManFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 5a1 1 0 10-1 1v2a3 3 0 110-6 3 3 0 010 6V6a1 1 0 001-1zM20 12a1 1 0 00-1-1h-6a1 1 0 00-1 1v7h-2v-7a3 3 0 013-3h6a3 3 0 013 3v7h-2v-7zM15 19v11h-2V19h2zM19 19v11h-2V19h2z",
    fill: props.color
  }));
}

export default SvgIconPeopleManFilled;